import { ComponentRoute } from '@/classes'

const SuperadminUsersRoutes = {
  UserListView: new ComponentRoute('/superadmin/users', 'SuperadminUserListView'),
  UserView: new ComponentRoute('/superadmin/users', 'SuperadminUserView'),
  UserDetail: new ComponentRoute('/superadmin/users/:userId', 'SuperadminUserDetail'),
  UserProfile: new ComponentRoute('/superadmin/userprofile/:userId', 'SuperadminUserProfile'),
  UserAccessControl: new ComponentRoute('/superadmin/accesscontrol/:userId', 'SuperadminUserAccessControl'),
  UserAccessRestriction: new ComponentRoute('/superadmin/accessrestriction/:userId', 'SuperadminUserAccessRestriction')
}

export default SuperadminUsersRoutes
